<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="filteredContent"
      :page.sync="tableOptions.page"
      :search="tableSearch"
      :items-per-page="tableOptions.itemsPerPage"
      @page-count="tableOptions.pageCount = $event"
      :sort-by="sortBy"
      :sort-asc="sortDirection"
      :sort-desc="!sortDirection"
      hide-default-footer
      :loading="loading"
      dense
      class="max-width font-weight-medium"
    >
      <!-- <template v-slot:header="{ props }">
        <tr class="filter-row">
          <th v-for="header in props.headers" :key="header.text" class="pa-1">
            <div v-if="filters.hasOwnProperty(header.value) && filteredContent.length > 0">
              <v-select
                class="ma-0 pa-0 table-filter caption"
                flat
                hide-details
                small
                multiple
                clearable
                :menu-props="{
                  closeOnClick: false,
                  closeOnContentClick: false
                }"
                :items="columnValueList(header.value)"
                v-model="filters[header.value]"
                :color="tableColorDif"
                :item-color="tableColorDif"
              >
                <template v-slot:selection="{ item, index }">
                  <span :class="tableColorDif + '--text'" v-if="index === 0">{{ item }}</span>

                  <span v-if="index === 1 && filters[header.value].length > 1" class="grey--text caption"
                    >&nbsp;+{{ filters[header.value].length - 1 }}</span
                  >
                </template>
              </v-select>
            </div>
          </th>
        </tr>
      </template> -->
      <template v-slot:body="{ items }">
        <tbody class="table-body">
          <tr v-for="item in items" :key="item.id">
            <td
              v-for="(header, index) in headers"
              :key="index"
              class="pa-1 pl-4"
              :class="
                item[header.value] !== '' &&
                  (header.text === 'Project' ? 'pointer-hover' : header.text.startsWith('Issue') ? 'pointer-hover' : '')
              "
              @click.prevent="tableRowClick(item, header.text)"
            >
              <div v-if="header.type === 'date'">
                {{ formattedDate(item[header.value]) }}
                <!-- {{ item[header.value] | format(new Date(item[header.value]), 'MM/DD/YYYY') }} -->
              </div>
              <div v-if="header.tooltip">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ item[header.value] | truncate(header.truncate, '...') }}</span>
                  </template>
                  <div>{{ item[header.value] }}</div>
                </v-tooltip>
              </div>
              <div v-if="header.type !== 'date' && !header.tooltip" :class="header.class">
                {{ item[header.value] }}
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <div class="text-center pt-4">
      <v-pagination
        v-model="tableOptions.page"
        class="table-pagination"
        :length="tableOptions.pageCount"
        :total-visible="7"
        color="bdoRed"
        prev-icon="mdi-arrow-left"
        next-icon="mdi-arrow-right"
      ></v-pagination>
    </div>

    <!-- <div v-if="emptyResult" class="max-width table-empty">
      <p>No {{ dataName }}</p>
    </div> -->
  </div>
</template>

<script>
import { format } from 'date-fns'
export default {
  name: 'data-table',
  data: () => ({}),
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    headervalues: {
      type: Array,
      default: () => []
    },
    tableContent: {
      type: Array,
      default: () => []
    },
    tableSearch: {
      type: String,
      default: ''
    },
    tableOptions: {
      type: Object,
      default: () => {}
    },
    tableColor: {
      type: String,
      default: ''
    },
    tableColorDif: {
      type: String,
      default: ''
    },
    filters: {
      type: Object,
      default: () => {}
    },
    sortBy: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    dataName: {
      type: String,
      default: ''
    }
  },
  computed: {
    sortDirection() {
      let asc = true
      switch (this.tableOptions.sortOrder) {
        case 'asc':
          asc = true
          break
        case 'desc':
          asc = false
          break
        default:
          asc = true
          break
      }
      return asc
    },
    emptyResult() {
      if (this.tableContent.length > 0) {
        return false
      } else {
        return true
      }
    },
    filteredContent() {
      if (this.tableContent.length == 0) return []
      return this.tableContent.filter(d => {
        return Object.keys(this.filters).every(f => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f])
        })
      })
    }
  },
  mounted() {},
  methods: {
    formattedDate(val) {
      return format(new Date(val), 'DD-MM-YYYY')
    },
    tableRowClick(i, h) {
      this.$emit('rowClick', i, h)
    },
    columnValueList(val) {
      let arr = this.tableContent.map(d => d[val])
      let filterArr = arr.sort((a, b) => (a > b ? 1 : -1))
      return filterArr
    }
  }
}
</script>

<style lang="scss" scoped>
.v-data-table td,
.v-data-table th {
  padding: 0 16px;
}

.v-data-table th:first-child {
  min-width: 120px;
}
</style>
<style lang="scss">
@import '@/style/_variables.scss';

.v-data-table-header tr th {
  height: 75px !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.6) !important;
}
.v-data-table-header tr th span {
  font-family: 'proxima-nova', Arial;
  font-size: 14px;
}
.table-filter {
  color: $background-2;
}
.table-filter .v-input__control .v-input__slot::before,
.table-filter .v-input__control .v-input__slot::after {
  display: none;
}
.table-filter .v-input__control .v-input__slot .v-select__slot .v-select__selections span {
  text-transform: uppercase;
}
.v-data-table {
  min-height: 428px;
  tr {
    &:hover {
      cursor: pointer;
    }
  }
}
.v-pagination li {
  .v-pagination__navigation,
  .v-pagination__item,
  .v-pagination__item--active {
    box-shadow: none;
  }
  .v-pagination__navigation:focus,
  .v-pagination__item:focus {
    outline: none;
  }
}
.table-pagination {
  display: inline-block;
}
</style>
